import { atom } from 'jotai';
import { atomEmptyNull } from 'utils/atomUtils';
import { ReactNode } from 'react';
import {
  Booking,
  TripCalculatorInsuranceTypeEnum,
  Boat,
  DomesticV2InsurersInsurerIdInsuranceStatusGet200Response,
} from 'swagger/models';

interface TripCalculation extends Booking {
  insurance_type?: string | TripCalculatorInsuranceTypeEnum;
}

export const isInquiryAtom = atom<boolean>(false);
export const boatIdAtom = atom<string>('');
export const bookingIdAtom = atom<string>('');

export const isPromoCodeAppliedAtom = atom<boolean>(false);
export const promoCodeValueAtom = atomEmptyNull<string>();
export const promoCodeErrorAtom = atom<boolean>(false);

export const selectedCreditCardAtom = atomEmptyNull<{ value: string; label: ReactNode }>();
export const isAddingNewCardAtom = atom<boolean>(false);
export const tripCalculationAtom = atom<TripCalculation>({});

export const checkoutBookingTripAtom = atom<Booking | TripCalculation>({});
export const checkoutBoatAtom = atom<Boat>({});
export const checkoutRenterInsuranceAtom = atom<DomesticV2InsurersInsurerIdInsuranceStatusGet200Response>({});

export const isBuoyBookingAtom = atom<boolean>(false);
export const isCommercialAtom = atom<boolean>(false);
export const purchasingAssuranceAtom = atomEmptyNull<boolean>();
